import Box from '@mui/material/Box';
import CircularProgress from '@mui/material/CircularProgress';

const LoadingIndicator = () => {
  return (
    <Box
      className='flex items-center justify-center h-screen w-screen bg-gray-100'
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
      }}
    >
      <CircularProgress size={64} className='text-blue-500' />
      <Box
        sx={{
          marginTop: 2,
        }}
      >
        <span className='text-gray-600 text-lg'>Page is loading...</span>
      </Box>
    </Box>
  );
};

export default LoadingIndicator;
